import {  useState, useEffect } from 'react';
import { FaTrash } from "react-icons/fa";
import TeacherLayout from "./TeacherLayout";
import CustomizedSnackbars from "../../Feedback";
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import online from '../../../assets/Dashboard/online-learning.svg';
import { deleteClassAction } from "../../../Firebase/actions/deleteClassAction";

const RemoveClass = ({ classes, deleteClassError, deleteClassSuccess, deleteClassAction, admins, auth,resetSuccess }) => {
    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    // simualting student object from db
    let classRooms;
    if(auth.uid) {       
        if (classes) {
            
            classRooms = classes.filter((item) => {
                return item.teacherId === auth.uid
            });  
        console.log(classRooms, auth.uid);
            
        }     
    }
    // ======

    //console.log(classes);
    const deleteClass = (id) => {
        //go to database and delete record using id param
        deleteClassAction(id)    
    }

    useEffect(() => {
        if(deleteClassSuccess) {
             //on success
            setFeedbackText('Class removed successfully.');
            setSeverity('success');
            setOpenFeedback(true);

            resetSuccess();
        }

        if(deleteClassError) {
            //on error
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);
        }
        
    }, [deleteClassError, deleteClassSuccess, resetSuccess]);
    return ( 
        <TeacherLayout>
            <div className="pt-5">
                <div className="container">
                    <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">Remove Classroom:</h5>
                    <div className="divider mb-5"></div>

                    <div className="row">
                        {
                            classRooms && (
                                classRooms.length !== 0 ? classRooms.map(classRoom => (
                                    <div
                                         className="col s12 m4 l4"
                                         key={classRoom.id}
                                    >
                                        <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                            <p className="grey-text text-darken-2 center is-size-5">{classRoom.moduleName}</p>
                                            <p className="grey-text has-text-weight-light my-3 center is-size-6">{classRoom.teacher}</p>
                                            <p className="grey-text text-darken-2 center mt-2 mb-3 is-size-6">Class Code: {classRoom.programmeCode}</p>
                                            <div className="center">
                                                <div 
                                                    className="button main-color mt-3 mb-1"
                                                    onClick={() => deleteClass(classRoom.id)}
                                                >
                                                    <span className="icon">
                                                        <FaTrash color="white"/>
                                                    </span>
                                                    <span className="white-text">Delete Class</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )) : (
                                    <div className="container pt-6">
                                        <p className="center has-text-weight-semibold grey-text text-darken-2 is-size-4 mb-2">You are yet to upload a class!</p>
                                        <div className="dashboard-illustration container">
                                            <img src={online} alt="Illustration" />
                                        </div>
                                    </div>
                                )

                            ) 
                        }
                        
                    </div>
                </div>
            </div>
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </TeacherLayout>
     );
}

const mapStateToProps = (state) => {
    console.log(state)
    return {
        classes: state.firestore.ordered.classes,
        deleteClassSuccess: state.deleteClass.deleteClassSuccess,
        deleteClassError: state.deleteClass.deleteClassError,
        admins: state.firestore.ordered.admins,
        auth: state.firebase.auth
    }
    
}
 

const mapDispatchToProps = (dispatch) => {
    return {
        deleteClassAction: (id) => dispatch(deleteClassAction(id)),
        resetSuccess: () => dispatch({ type: "DELETE_CLASS", success: false })
    };
};
  
 
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "classes", 
            },
            {
                collection: "admins", 
            }
    ])
)(RemoveClass);